<template>
    <svg
        :width="width"
        :height="height"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="color"
    >
        <template v-if="weight === 'OFF'">
            <path
                d="M7.66694 4.40013C7.9983 4.40013 8.26693 4.66876 8.26693 5.00013V8.08502L9.74103 9.55912C9.97534 9.79343 9.97534 10.1733 9.74103 10.4076C9.50671 10.642 9.12681 10.642 8.8925 10.4076L7.24259 8.75773C7.12291 8.63804 7.06435 8.48037 7.06694 8.32352V5.00013C7.06694 4.66876 7.33557 4.40013 7.66694 4.40013Z"
                fill="currentColor" />
            <path fill-rule="evenodd" clip-rule="evenodd"
                d="M8.00036 1.40039C4.3553 1.40039 1.40039 4.35531 1.40039 8.00039C1.40039 11.6455 4.3553 14.6004 8.00036 14.6004C11.6454 14.6004 14.6003 11.6455 14.6003 8.00039C14.6003 4.35531 11.6454 1.40039 8.00036 1.40039ZM2.60039 8.00039C2.60039 5.01805 5.01804 2.60039 8.00036 2.60039C10.9827 2.60039 13.4003 5.01805 13.4003 8.00039C13.4003 10.9827 10.9827 13.4004 8.00036 13.4004C5.01804 13.4004 2.60039 10.9827 2.60039 8.00039Z"
                fill="currentColor" />
        </template>
</svg>
</template>

<script>
export default {
    name: 'clock-on-icon',
    props: {
        width: {
            type: [String, Number],
            default: 24,
        },
        height: {
            type: [String, Number],
            default: 24,
        },
        color: {
            type: String,
            default: 'text-black',
        },
        weight: {
            type: String,
            default: 'REGULAR',
            validator: (val) => ['REGULAR', 'FILL','OFF'].includes(val),
        },
    },
};
</script>
